module.exports = __webpack_public_path__ + "media/images/help/browse_img_1-f0fcea66c18af30d4e4c296f386d8aa9.jpeg";